import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    employeeList: [],
    employeeListCount: null,
    employeeFilter: {
        main_filter: null,
        fields: {
            employeeId: null,
        },
    },
    employeeModalOpen: false,
    employee_id: null,
    employee_index: null,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
